module.exports = __webpack_public_path__ + "static/media/lassing_rural.e97ba769.png";